import {IconButton} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import {openPatientForm} from '../../store/reducers/patientContext';
import {useDispatch, useSelector} from 'react-redux';
import {additionalData, patientHistoryData} from '../../store/reducers/additionalData';

const HistoryFormButton = ({openFormPath, disabled, isPatientAddData, multiplePath, customHistoryData, setLoading}) => {
    const dispatch = useDispatch();

    // Selectors
    const ptHistData = useSelector(patientHistoryData);
    const patientAddData = useSelector(additionalData);

    const [showHistory, setShowHistory] = useState(false);

    useEffect(() => {
        let haveHistory = false;

        if (!_.isEmpty(customHistoryData)) {
            const filtered = _.filter(customHistoryData, d => !d?.canceled);
            haveHistory = filtered?.length > 0;
        } else if (!isPatientAddData) {
            _.forEach(ptHistData, piw => {
                if (haveHistory) return;

                let getData = _.get(piw, multiplePath);
                if (multiplePath === 'studies.auditC.list') {
                    const auditC = _.get(piw, 'studies.auditC');
                    if (_.isArray(auditC?.list)) {
                        getData = auditC.list;
                    } else if (auditC && !_.isEmpty(auditC)) {
                        getData = [auditC];
                    }
                }
                const filtered = _.filter(getData, d => !d?.canceled);
                haveHistory = filtered?.length > 0;
            });
        } else {
            const data = _.get(patientAddData, multiplePath);
            const filtered = _.filter(data, d => !d?.status !== 'CANCELED');
            haveHistory = filtered?.length > 0;
        }
        setLoading(false);
        setShowHistory(haveHistory);
    }, [ptHistData, customHistoryData]);

    const handleOpenHistoryList = () => {
        if (!disabled && openFormPath) {
            dispatch(openPatientForm(`$multi_${openFormPath}`));
        }
    };

    if (!showHistory) return null;

    return (
        <IconButton
            size="small"
            onClick={handleOpenHistoryList}
            className="disabled-options"
        >
            <HistoryIcon fontSize="small"/>
        </IconButton>
    );
};

export default HistoryFormButton;
